export const SaveLegalInputs = (fields) => {
  return {
    type: 'GET_LEGAL_DATA',
    payload: { ...fields },
  };
};

export const SubmitSignatureForm = (fields) => {
  return {
    type: 'SUBMIT_SIGNATURE_DATA',
    payload: { ...fields },
  };
};

export default { SaveLegalInputs, SubmitSignatureForm };
